/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ExternalFeedAttachments_data = {
    readonly nodes: ReadonlyArray<{
        readonly slug: string;
        readonly " $fragmentRefs": FragmentRefs<"SmallAttachment_attachment">;
    } | null> | null;
    readonly " $refType": "ExternalFeedAttachments_data";
};
export type ExternalFeedAttachments_data$data = ExternalFeedAttachments_data;
export type ExternalFeedAttachments_data$key = {
    readonly " $data"?: ExternalFeedAttachments_data$data;
    readonly " $fragmentRefs": FragmentRefs<"ExternalFeedAttachments_data">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ExternalFeedAttachments_data",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Attachment",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "slug",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SmallAttachment_attachment"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AttachmentConnection",
  "abstractKey": null
};
(node as any).hash = '610a17353069ad55b9c11f5e8805097f';
export default node;
